import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { clearNotification } from "../../redux/slices/notificationSlice";
import { XCircle, CheckCircle, AlertTriangle, Info } from "lucide-react";

export default function Notification({ message, type, title }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (message) {
      setShow(true);
      const timer = setTimeout(() => {
        setShow(false);
        dispatch(clearNotification());
      }, 5000); // Auto close after 5s
      return () => clearTimeout(timer);
    }
  }, [message, dispatch]);

  if (!message || !show) return null;

  const notificationStyles = {
    success: {
      bg: "bg-green-50 border-green-400 text-green-800",
      icon: <CheckCircle className="w-5 h-5 text-green-600" />,
    },
    error: {
      bg: "bg-red-50 border-red-400 text-red-800",
      icon: <XCircle className="w-5 h-5 text-red-600" />,
    },
    info: {
      bg: "bg-blue-50 border-blue-400 text-blue-800",
      icon: <Info className="w-5 h-5 text-blue-600" />,
    },
    warning: {
      bg: "bg-yellow-50 border-yellow-400 text-yellow-800",
      icon: <AlertTriangle className="w-5 h-5 text-yellow-600" />,
    },
  };

  const currentStyle = notificationStyles[type] || notificationStyles.info;

  return (
    <div className={`w-full border-t-4 ${currentStyle.bg} ${currentStyle.border} p-3 flex items-start`}>
      {currentStyle.icon}
      <div className="ml-3 flex-1">
        <p className="text-sm font-medium">{title}</p>
        <p className="text-sm">{message}</p>
      </div>
      <button onClick={() => setShow(false)} className="ml-3 text-gray-500 hover:text-gray-700">
        ✕
      </button>
    </div>
  );
}
